import { EPlanType } from '~/constants/organizationPlan'
import { PermissionTypeEnum } from '~/services/MSAPI/user/types'

export interface INavigationGuardConditions {
  requiresPlanCorporate?: boolean
  requiresPlanNotFree?: boolean
  requiresSenditUser?: boolean
  requiresBalanceBillingOverview?: boolean
  requiresBalanceBillingInvoices?: boolean
  requiresBalanceBillingConsumptionReport?: boolean
  requiresOrganizationCreate?: boolean
  canAccessTwoWay?: boolean
  isDefaultRoute?: boolean
}

export const useNavigationGuard = () => {
  const authStore = useAuthStore()
  const { hasSessionPermission } = usePermissionUtils()

  const checkNavigationAccess = (
    conditions?: INavigationGuardConditions,
  ): boolean => {
    if (!conditions) return true

    const { organizationData, isSenditUser } = authStore

    if (
      conditions.requiresPlanCorporate &&
      organizationData.planType !== EPlanType.CORPORATE
    ) {
      return false
    }

    if (
      conditions.requiresPlanNotFree &&
      organizationData.planType === EPlanType.TRIAL
    ) {
      return false
    }

    if (conditions.requiresSenditUser && !isSenditUser) {
      return false
    }

    if (conditions.requiresBalanceBillingOverview) {
      return hasSessionPermission(PermissionTypeEnum.Balance_Billing_Overview)
    }

    if (conditions.requiresBalanceBillingInvoices) {
      return hasSessionPermission(PermissionTypeEnum.Balance_Billing_Invoices)
    }

    if (conditions.requiresBalanceBillingConsumptionReport) {
      return hasSessionPermission(
        PermissionTypeEnum.Balance_Billing_Consumption_Report,
      )
    }

    if (conditions.requiresOrganizationCreate) {
      return hasSessionPermission(PermissionTypeEnum.Organization_Create)
    }

    return true
  }

  return { checkNavigationAccess }
}
